import Vue from 'vue';
import yxToast from '@/components/yx-toast';
import { createApp } from '@/index';
import "babel-polyfill";
import '@/static/style/fonts/icon.css';
import '@/static/style/mixins.scss';
Vue.use(yxToast);

let { app, router, store } = createApp();
router.onReady(() => {
    router.beforeResolve((to, from, next) => {
        const matched = router.getMatchedComponents(to)
        const prevMatched = router.getMatchedComponents(from)
        let diffed = false
        const activated = matched.filter((c, i) => {
            return diffed || (diffed = (prevMatched[i] !== c))
        })
        if (!activated.length) {
            return next()
        }
        Promise.all(activated.map(c => {
            if (c.asyncData) {
                return c.asyncData({ store, route: to })
            }
        })).then(() => {
            next()
        }).catch(next)
    })
    app.$mount('#app')
})


// WEBPACK FOOTER //
// ./entrys/entryClient.js